import { empty as observableEmpty,
         Observable,
         throwError as observableThrowError,
         BehaviorSubject, 
         firstValueFrom,
         of } from 'rxjs'

import { catchError,
         distinctUntilChanged,
         map } from 'rxjs/operators'

import { Injectable } from '@angular/core'

import { ApiService } from './api.service'

import { Message } from '../_models/message.model'
import { HttpParams } from '@angular/common/http'

import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class MessageService {

  private selectedMessageSubject = new BehaviorSubject<Message>(null)
  public selectedMessage = this.selectedMessageSubject.asObservable().pipe(distinctUntilChanged())
  private selectedMessageLocal: Message

  constructor (
    private apiService: ApiService,
    private matSnackbar: MatSnackBar
  ) {}

  messageFromData(data: any): Message {
    // console.log('entryFromData', data, updateSelectedEntry)
    if (!data) return
    if (data['error'] === 'pundit') { console.warn('err: messageFromData-pundit', data['error']); return data }
    let message = new Message(data)
    // data['root_url'] = window.location.origin
    return message
  }

  shouldUpdateSelectedMessage(message: Message, updateSelectedMessage: boolean) {
    if (updateSelectedMessage) return true
    if (!this.selectedMessageLocal) return false
    if (message.id === this.selectedMessageLocal['id']) return true
    return false
  }

  updateSelectedMessage(message:Message): any {
    this.selectedMessageSubject.next(message)
    this.selectedMessageLocal = message
    return message
  }

  // getMessage(id: string): Observable<Message> {
  //   return this.apiService.get('messages/' + id).pipe(
  //       catchError(err => this.handleError(err) ),
  //       map( (res: Message) => this.messageFromData(res)
  //   ))
  // }
  
  async getMessages(params:any = {}): Promise<Message[]> {
    let url = 'messages'

    let routeParams = new HttpParams()
      .set('page', params['page'])
      .set('limit', params['limit'])
      .set('sortBy', params['sortBy'])  // : {}


    return firstValueFrom(this.apiService.get(url, routeParams).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: Message[]) => {
        res['results'] = res['results'].map(u => new Message(u)) 
        return res
      }) // this.messageFromData(res)
    ))
  }

  async findMessageBy(params:any = {}): Promise<Message> {
    let url = 'messages/find'
    return firstValueFrom(this.apiService.post(url, params).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: Message) => this.messageFromData(res)
    )))
  }

  // Update the message on the server
  // TODO: DTO instead of raw message
  update(message: Message): Observable<Message> {
    return this.apiService
      .put('messages/' + message.id, message)
      .pipe(map(data => {
        return this.messageFromData(data)
      }))
  }

  // TODO: DTO instead of raw message
  create(message: Message): Observable<Message> {
    // console.log('creating message?', message)
    
    return this.apiService
      .post('messages/create', message)
      .pipe(
        // catchError(err => this.handleError(err) ),
        map(data => {
          // console.log('new-message-data', data)
          return this.messageFromData(data)
        }));
  }

  delete(message: Message): Observable<Message> {
    // console.log('TODO: delete message', message)
    return this.apiService
      .post('messages/' + message.id + '/delete')
      .pipe(map(data => {
        // console.log('DELETED', message)
        return data
        return this.messageFromData(data)
      }))
  }

  handleError(err: any) {
    console.warn('ERR: message.service handled', err)
    this.matSnackbar.open(`ERROR: ${err.message}`, 'close', { duration: 5000 });
    if (!err) return Promise.reject()
    return observableThrowError(err)
  }

}
